module.exports = __webpack_public_path__ + "img/card-purple.9451affb.svg";